import { configureStore } from "@reduxjs/toolkit";
import readOnlyReducer from "./slices/readOnly";

export const store = configureStore({
  reducer: {
    readOnly: readOnlyReducer,
  },
});
